import { render, staticRenderFns } from "./ModalImport.vue?vue&type=template&id=6da435de"
import script from "./ModalImport.vue?vue&type=script&lang=ts"
export * from "./ModalImport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports